/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/ProjectOverviewPageDataProviderSource" />
import { Constants, ProjectOverviewPageScenarios } from "TFS/Views/ProjectOverviewPage/Constants";
import { ProjectOverviewPageData } from "TFS/Views/ProjectOverviewPage/Shared/Models";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPerformanceService } from "VSS/Platform/Performance";
export interface ProjectOverviewPageDataProviderData {
    projectOverviewPageData: ProjectOverviewPageData;
}

export class ProjectOverviewPageDataProviderSource {
    private static PROVIDER_ID = "ms.vss-tfs-web.project-overview-page-data-provider-verticals";

    constructor(private _pageContext: IVssPageContext) {}

    public getProjectOverviewPageData(): Promise<ProjectOverviewPageData | undefined> {
        const performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.startScenario(ProjectOverviewPageScenarios.GetOverviewPageData, false);
        return this._pageContext
            .getService<IVssContributionService>("IVssContributionService")
            .getDataAsync<ProjectOverviewPageDataProviderData>(ProjectOverviewPageDataProviderSource.PROVIDER_ID)
            .then(
                (data: ProjectOverviewPageDataProviderData | undefined) => {
                    performanceService.endScenario(Constants.Area, ProjectOverviewPageScenarios.GetOverviewPageData, false);
                    return !!data ? data.projectOverviewPageData : undefined;
                },
                (error: Error) => {
                    performanceService.endScenario(Constants.Area, ProjectOverviewPageScenarios.GetOverviewPageData, false, undefined, {
                        status: "failed"
                    });
                    throw error;
                }
            );
    }
}
